import { ReactNode } from "react"

export const WhiteBox = ({ className = '', children }: { className?: string, children: ReactNode }) => {
  return <div className={className + ' mt-7 mb-3 p-7 bg-white rounded-xl '}>
    {children}
  </div>
}